import { create } from 'zustand';

interface SelectionState {
  paths: string[];
  anchor: string | null;
  isSelected: (path: string) => boolean;
  set: (paths: string[]) => void;
  toggle: (path: string) => void;
  selectOnly: (path: string) => void;
  range: (ordered: string[], to: string) => void;
  clear: () => void;
}

export const useSelection = create<SelectionState>((set, get) => ({
  paths: [],
  anchor: null,

  isSelected: (path) => get().paths.includes(path),
  set: (paths) => { set({ paths, anchor: paths[paths.length - 1] ?? null }); },

  toggle: (path) => {
    const current = get().paths;
    const next = current.includes(path)
      ? current.filter((p) => p !== path)
      : [...current, path];
    set({ paths: next, anchor: path });
  },

  selectOnly: (path) => { set({ paths: [path], anchor: path }); },

  /** Shift+클릭: 기준점(anchor)에서 대상까지 화면에 보이는 순서대로 선택한다. */
  range: (ordered, to) => {
    const anchor = get().anchor ?? to;
    const from = ordered.indexOf(anchor);
    const target = ordered.indexOf(to);
    if (from < 0 || target < 0) { set({ paths: [to], anchor: to }); return; }
    const [start, end] = from <= target ? [from, target] : [target, from];
    set({ paths: ordered.slice(start, end + 1) });
  },

  clear: () => { set({ paths: [], anchor: null }); },
}));
